/* eslint-disable no-unused-expressions */
import CompanyCorporate from './company-corporate';

class CompaniesCorporateCollectionUIModel {
  constructor({
    companies = [],
  } = {}) {
    this.companies = companies?.length > 0 ? companies?.map(company => new CompanyCorporate(company)) : [];
  }

  getCompanies() {
    return this.companies?.map(company => ({ name: company?.companyName, values: company?.companyName }));
  }

  getCompanySelected() {
    if (this.companies?.length > 1)
      return this.companies?.find(company => company?.isSelected);
    return this.companies?.[0];
  }

  getNameCompany() {
    return this.getCompanySelected()?.companyName || '';
  }

  getDiscountCode() {
    return this.getCompanySelected()?.discountCode || '';
  }

  getCorporateEmail() {
    return this.getCompanySelected()?.emailAddressCompany || '';
  }

  getLoyaltyNumber() {
    return this.getCompanySelected()?.companyLoyaltyNumber || '';
  }

  getUserId() {
    return this.getCompanySelected()?.travelerId || '';
  }

  setCompanySelected(nameSelected) {
    this.companies?.forEach(company => {
      company.setCompanySelected(company.companyName === nameSelected);
    });
  }
}
  
export default CompaniesCorporateCollectionUIModel;